import FluxoAquisicaoDefault from "./FluxoAquisicaoDefault";
import { useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { getComplementoOperacao } from "../../../../selectors/operacao.selectors";

const FluxoAquisicaoDefaultConnected = () => {
  const [step, setStep] = useState(0);
  const [participante, setParticipante] = useState(null);
  const [events, setEvents] = useState(null);

  const {
    operacao: { participantes },
    validacao,
  } = useSelector(getComplementoOperacao);

  const compradores = useMemo(
    () =>
      participantes
        .filter((p) => p.tipoParticipante === "CO")
        .map((c) => ({
          ...c,
          fluxo: validacao.completa.participantes.find((f) => f.id === c?.id)
            ?.etapas,
        }))
        .sort((c1, c2) =>
          c1.principal
            ? -1
            : c2.principal
              ? 1
              : (c1.nome ?? "").localeCompare(c2.nome ?? "")
        ),
    [participantes, validacao]
  );

  const vendedores = useMemo(
    () =>
      participantes
        .filter((p) => p.tipoParticipante === "VD")
        .map((c) => ({
          ...c,
          representantes: c.representantes?.map(r => ({
            ...r,
            fluxo: validacao.completa.participantes.find((f) => f.id === r?.id)?.etapas
          })),
          fluxo: validacao.completa.participantes.find((f) => f.id === c?.id)?.etapas,
        }))
        .sort((c1, c2) =>
          c1.principal
            ? -1
            : c2.principal
              ? 1
              : (c1.nome ?? "").localeCompare(c2.nome ?? "")
        ),
    [participantes, validacao]
  );

  const sortId = (id, parent) => (parent ?? id) * 10 + id;

  const socios = useMemo(
    () =>
      participantes
        .filter((p) => p.tipoParticipante === "RL")
        .map((c) => ({
          ...c,
          fluxo: validacao.completa.participantes.find((f) => f.id === c?.id)?.etapas,
        }))
        .sort(
          (c1, c2) =>
            sortId(c1.id, c1.participanteOrigem) -
            sortId(c2.id, c2.participanteOrigem)
        ),
    [participantes, validacao]
  );

  const makeGoTo = useCallback(
    (s) => {
      return () => {
        setStep(s);
      };
    },
    [setStep]
  );
  const handleGoTo0 = useCallback(() => {
    setStep(0);
  }, [setStep]);
  const handleGoTo1 = useCallback(() => {
    setStep(1);
  }, [setStep]);
  const handleGoTo2 = useCallback(() => {
    setStep(2);
  }, [setStep]);
  const handleGoTo3 = useCallback(() => {
    setStep(3);
  }, [setStep]);
  const handleGoTo4 = useCallback(() => {
    setStep(4);
  }, [setStep]);
  const handleGoTo5 = useCallback(() => {
    setStep(5);
  }, [setStep]);
  const handleGoTo6 = useCallback(() => {
    setStep(6);
  }, [setStep]);
  const handleGoTo7 = useCallback(() => {
    setStep(7);
  }, [setStep]);
  const handleGoTo9 = useCallback(() => {
    setStep(9);
  }, [setStep]);
  const handleGoTo10 = useCallback(() => {
    setStep(10);
  }, [setStep]);
  const handleGoTo11 = useCallback(() => {
    setStep(11);
  }, [setStep]);
  const handleGoTo12 = useCallback(() => {
    setStep(12);
  }, [setStep]);
  const handleGoTo20 = useCallback(() => {
    setStep(20);
  }, [setStep]);
  const handleGoTo21 = useCallback(() => {
    setStep(21);
  }, [setStep]);
  const handleGoTo60 = useCallback(() => {
    setStep(60);
  }, [setStep]);
  const handleGoTo100 = useCallback(() => {
    setStep(100);
  }, [setStep]);
  const handleGoTo101 = useCallback(() => {
    setStep(101);
  }, [setStep]);
  const handleGoTo102 = useCallback(() => {
    setStep(102);
  }, [setStep]);
  const handleGoTo999 = useCallback(() => {
    setStep(999);
  }, [setStep]);
  const handleGoTo998 = useCallback(() => {
    setStep(998);
  }, [setStep]);
  const eventsCompradorPrincipal = [
    handleGoTo1,
    handleGoTo2,
    handleGoTo3,
    handleGoTo4,
    handleGoTo5,
    handleGoTo7,
  ];
  const eventsComprador = [
    handleGoTo1,
    handleGoTo2,
    handleGoTo3,
    handleGoTo4,
    handleGoTo7,
  ];
  const eventsCompradorDps = [
    handleGoTo1,
    handleGoTo2,
    handleGoTo3,
    handleGoTo4,
    handleGoTo9,
    handleGoTo7,
  ];
  const eventsVendedorPf = [handleGoTo10, handleGoTo11, handleGoTo12];
  const eventsVendedorPj = [handleGoTo20, handleGoTo11, handleGoTo6];
  const eventsImovel = [handleGoTo100, handleGoTo101, handleGoTo102];
  const eventsSocios = [handleGoTo60];

  return (
    <FluxoAquisicaoDefault
      step={step}
      setStep={setStep}
      participante={participante}
      setParticipante={setParticipante}
      compradores={compradores}
      vendedores={vendedores}
      events={events}
      socios={socios}
      setEvents={setEvents}
      eventsComprador={eventsComprador}
      eventsCompradorPrincipal={eventsCompradorPrincipal}
      eventsCompradorDps={eventsCompradorDps}
      eventsVendedorPf={eventsVendedorPf}
      eventsVendedorPj={eventsVendedorPj}
      eventsImovel={eventsImovel}
      eventsSocios={eventsSocios}
      handleGoTo0={handleGoTo0}
      handleGoTo1={handleGoTo1}
      handleGoTo2={handleGoTo2}
      handleGoTo3={handleGoTo3}
      handleGoTo4={handleGoTo4}
      handleGoTo5={handleGoTo5}
      handleGoTo7={handleGoTo7}
      handleGoTo9={handleGoTo9}
      handleGoTo10={handleGoTo10}
      handleGoTo11={handleGoTo11}
      handleGoTo12={handleGoTo12}
      handleGoTo20={handleGoTo20}
      handleGoTo21={handleGoTo21}
      handleGoTo60={handleGoTo60}
      handleGoTo100={handleGoTo100}
      handleGoTo101={handleGoTo101}
      handleGoTo102={handleGoTo102}
      handleGoTo998={handleGoTo998}
      handleGoTo999={handleGoTo999}
      makeGoTo={makeGoTo}
    />
  );
};

export default FluxoAquisicaoDefaultConnected;
